import React, { useId, useRef } from 'react'
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text
} from '@chakra-ui/react'

type UtilityChargebackChooserModalProps = {
  isOpen: boolean
  onChooseBillBacked: () => void
  onChooseOrphaned: () => void
  onClose: () => void
}

export default function UtilityChargebackChooserModal({
  isOpen,
  onChooseBillBacked,
  onChooseOrphaned,
  onClose
}: UtilityChargebackChooserModalProps) {
  const billBackedActionRef = useRef<HTMLButtonElement>(null)
  const billBackedLabelId = useId()
  const billBackedDescriptionId = useId()
  const orphanedLabelId = useId()
  const orphanedDescriptionId = useId()

  return (
    <Modal
      initialFocusRef={billBackedActionRef}
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      size='lg'
    >
      <ModalOverlay />
      <ModalContent mx={4}>
        <ModalHeader pb={2} pr={12}>
          Create Utility Chargeback
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <Stack spacing={4}>
            <Button
              ref={billBackedActionRef}
              aria-describedby={billBackedDescriptionId}
              aria-labelledby={billBackedLabelId}
              colorScheme='teal'
              h='auto'
              justifyContent='flex-start'
              onClick={onChooseBillBacked}
              px={4}
              py={3}
              whiteSpace='normal'
            >
              <Stack align='start' spacing={0.5} textAlign='left'>
                <Text id={billBackedLabelId}>Charge Back a Utility Bill</Text>
                <Text
                  id={billBackedDescriptionId}
                  color='whiteAlpha.900'
                  fontSize='sm'
                  fontWeight='normal'
                >
                  Use an existing utility bill already recorded for the property.
                </Text>
              </Stack>
            </Button>
            <Button
              aria-describedby={orphanedDescriptionId}
              aria-labelledby={orphanedLabelId}
              h='auto'
              justifyContent='flex-start'
              onClick={onChooseOrphaned}
              px={4}
              py={3}
              variant='outline'
              whiteSpace='normal'
            >
              <Stack align='start' spacing={0.5} textAlign='left'>
                <Text id={orphanedLabelId}>Create Orphaned Utility Chargeback</Text>
                <Text id={orphanedDescriptionId} color='gray.600' fontSize='sm' fontWeight='normal'>
                  Use when there is no matching utility bill to select.
                </Text>
              </Stack>
            </Button>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
